import { handleRoute } from "../https";

export async function findEducationRequest({ companyId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/education-requests`,
  });
  return res;
}

export async function acceptEducationRequest({
  splitBy,
  centsInPayroll,
  centsAmountFromFunds,
  requestId,
  companyId,
}) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/recurrent-payments/education-benefit/${requestId}/approve`,
    payload: {
      splitBy,
      centsInPayroll,
      centsAmountFromFunds,
      requestId,
    },
  });
  return res;
}

export async function rejectEducationRequest({
  companyId,
  requestId,
  approved,
}) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/recurrent-payments/education-benefit/${requestId}/reject`,
    payload: { requestId, approved },
  });
  return res;
}

export const listCompanyRequests = async ({ companyId, category }) => {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/recurrent-payments/${category}/`,
  });
  return res;
};

export const listEmployeeRequests = async ({
  companyId,
  category,
  employeeId,
}) => {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}/recurrent-payments/${category}`,
  });
  return res;
};

export const denyRequest = async ({
  companyId,
  requestId,
  reason,
  category,
}) => {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/recurrent-payments/${category}/${requestId}/reject`,
    payload: { reason },
  });
  return res;
};

export const approveRequest = async ({
  companyId,
  requestId,
  category,
  payload,
}) => {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/recurrent-payments/${category}/${requestId}/approve`,
    payload,
  });
  return res;
};

export const reviewRequestDetails = async ({
  companyId,
  category,
  requestId,
  payload,
}) => {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/recurrent-payments/${category}/${requestId}/summary`,
    payload,
  });
  return res;
};
